/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

import type { ButtonAsType, ButtonProps } from '@motorway/mw-highway-code';

import ROUTES from 'Utilities/routes';

import { MOTORWAY_PAY_UNAUTHORISED_PARAM } from '../DiscoverMWPay.consts';

type DWMPHeroButtonProps<E extends ButtonAsType> = Omit<ButtonProps<E>, 'label'>;

export const getDiscoverMotorwayPayRedirectLink = (hash?: string) => {
	return `${ROUTES.SIGN_IN.href}?redirect=${encodeURIComponent(
		`${ROUTES.MOTORWAY_PAY.href}${hash ? `#${hash}` : ''}`,
	)}&unauthorised=${MOTORWAY_PAY_UNAUTHORISED_PARAM}`;
};

export const getDiscoverMotorwayPayButtonParams = ({
	external,
	hash,
	isLoggedOut,
	onClick,
}: {
	external?: string;
	hash?: string;
	isLoggedOut?: boolean;
	onClick?: () => void;
}) =>
	isLoggedOut
		? ({
				as: 'a',
				href: external ?? getDiscoverMotorwayPayRedirectLink(hash),
				onClick,
				target: external ? '_blank' : '_self',
		  } as DWMPHeroButtonProps<'a'>)
		: ({
				onClick,
		  } as DWMPHeroButtonProps<'button'>);
